'use strict'

import Api from '@/api/call.js'

const state = {
  error: null,
  loading: false
}

const actions = {
  store ({commit}, calls) {
    commit('store')

    console.info(calls)

    Api.store(calls)
      .then(data => commit('storeSuccess', data))
      .catch(err => commit('fetchFailure', err))
  }
}

const mutations = {
  store (state) {
    state.loading = true
  },

  storeSuccess (state, data) {
    state.loading = false
  },

  fetchFailure (state, err) {
    state.loading = false
    state.error = err
    console.error(err)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
